import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLoggedIn } from 'utils/auth';
import { isIOS, isAndroid } from 'utils/deviceUtils';
import { isAppVersionGreaterThanOrEqual, kNativeLoginVersion } from 'utils/versionUtils';
import { requestNativeLogout } from 'utils/nativeBridge';

interface AuthGuardProps {
  redirectTo?: string;
  children: React.ReactNode;
}

export function AuthGuard({ children, redirectTo }: AuthGuardProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn()) {
      // >= 8.8.0：鉴权失败通知 native 退出，由 native 控制登录页
      if (isIOS() || isAndroid()) {
        isAppVersionGreaterThanOrEqual(kNativeLoginVersion).then((supportsNativeLogin) => {
          if (supportsNativeLogin) {
            requestNativeLogout();
            return;
          }
          navigate(redirectTo || '/login');
        });
      } else {
        navigate(redirectTo || '/login');
      }
    }
  }, [navigate, redirectTo]);

  return <>{children}</>;
} 